import { getLabelMessage } from '@gef-ui/localization/messages';
import { useCallback } from 'react';
import { showErrorSingle } from '../../actions';
import { useErrorDispatch } from '../../context';
const useHandleErrorLogout = ()=>{
    const errorDispatch = useErrorDispatch();
    const handleErrorLogout = useCallback((type, logoutUrl)=>{
        errorDispatch(showErrorSingle({
            heading: getLabelMessage(`errors:${type}LogoutHeading`),
            shortDescription: getLabelMessage(`errors:${type}LogoutDescription`),
            screen: 'AUTH',
            logoutUrl
        }));
    }, [
        errorDispatch
    ]);
    return handleErrorLogout;
};
export default useHandleErrorLogout;
